import * as React from "react";
import { Box, Text } from "grommet";

import styled from "styled-components";

const Color = styled.span`
    width: 40px;
    height: 40px;
    border-radius: 12px;
    display: inline-block;
    background: ${(props) => (props.disabled ? "grey" : props.color)};
    transition: all 0.3s ease;
    box-shadow: 0 0 0 0px ${(props) => props.color};
    input {
        opacity: 0;
        width: 40px;
        height: 40px;
        display: block;
        border: none;
    }
    :hover {
        cursor: pointer;
        box-shadow: 0 0 0 2px ${(props) => props.color};
    }
`;

export const ColorPicker = styled.span`
    width: 120px;
    height: 40px;
    border-radius: 12px;
    display: inline-block;
    transition: all 0.3s ease;
    box-shadow: 0 0 0 0px white;
    input {
        opacity: 0;
        width: 120px;
        height: 40px;
        display: block;
        border: none;
    }
    :hover {
        cursor: pointer;
        box-shadow: 0 0 0 ${(props) => (props.disabled ? "0px" : "2px")} white;
    }
`;

const ThemeBuilder = ({ color: value, onSelect, disabled }: { color: string; onSelect: Function; disabled?: boolean }) => {
    const [color, setColor] = React.useState(value || "#000000");

    const selectColor = (color) => {
        if (!disabled) {
            setColor(color);
            onSelect && onSelect(color);
        }
    };

    const colors = ["#B10DC9", "#F012BE", "#FF4136", "#FFDC00", "#0074D9", "#2ECC40", "#39CCCC"];

    return (
        <div>
            <Box direction="row" align="center" gap="small">
                <Text>Choose a color</Text>

                <Box direction="row" gap="small" align="center">
                    {colors.map((c) => (
                        <Color key={c} disabled={disabled} color={c} onClick={() => selectColor(c)}></Color>
                    ))}
                    <Text>or pick your own</Text>
                </Box>

                <ColorPicker disabled={disabled} style={{ backgroundColor: color }}>
                    <input type="color" value={color} disabled={disabled} onChange={(e) => selectColor(e.target.value)} />
                </ColorPicker>
            </Box>
        </div>
    );
};

export default ThemeBuilder;
